import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IllustrationPendingSvg } from "./IllustrationPendingSvg.mjs";
const IllustrationPending = () => /* @__PURE__ */ jsx(Box, { component: IllustrationPendingSvg });
export {
  IllustrationPending
};
